export const removeSelectedProjectFromLocalStorage = () => {
    localStorage.removeItem("selectedProjectId");
    localStorage.removeItem("selectedProjectName");
};